// DragNDrop.js (estratto refactoring)
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

export class DragNDrop extends React.Component {
    UID = uuidv4();
    scope = null;
    type = null;
    name = null;
    label = null;
    defValue = null;
    childrens = [];

    define(scope, type, name, label, defValue) {
        this.scope = scope;
        this.type = type;
        this.name = name;
        this.label = label;
        this.defValue = defValue;
    }

    addChildren(child) {
        this.childrens.push(child);
    }

    removeChildren(child) {
        this.childrens = this.childrens.filter(item => item !== child);
    }

    getJSON() {
        return {
            formScope: this.scope,
            type: this.type,
            name: this.name,
            label: this.label,
            defaultValue: this.defValue,
            childrens: this.childrens.map(item => item.getJSON())
        };
    }

    render() {
        return (
            <>
                {this.label} | {this.name}<br/>
                {this.defValue}<br/>
                {this.scope} - {this.type}<br/><br/>
            </>
        );
    }
}
